/**
 * For code-splitting routes. See https://serverless-stack.com/chapters/code-splitting-in-create-react-app.html
 *
 * This method is invoked from client/src/components/dashboards/index.js. It's used to import ANY and ALL
 * dashboards containing TimeSeriesChartWidget or MultipleChartWidget components.
 *
 * These two use react-timeseries-charts, which drags along a large number of dependencies.
 *
 * When the client code is compiled by react-scripts, all the additional JS required by react-timeseries-charts will
 * land in a separate file in the build folder which doesn't need to be loaded for about half the dashboards
 * (e.g. Summary, Zenoss).
 */
import React, { Component } from 'react';

export default function (importComponent) {
  class AsyncComponent extends Component {
    constructor(props) {
      super(props);
      this.state = { component: null };
    }

    async componentDidMount() {
      const { default: component } = await importComponent();
      this.setState({ component });
    }

    render() {
      const { component: C } = this.state;
      return C ? <C {...this.props} /> : null;
    }
  }
  return AsyncComponent;
}
